export interface ItemResponseItem {
  orderItemId: number;
  itemSeqNum: number;
  quantity: number;
  product: {
    productId: number
    productCode: string
    productDesc: string
    productType: {
      productTypeId: number
      productTypeCode: string
      productTypeDesc: string
    }
  };
  uom: {
    unitId: number
    unitCode: string
    unitDesc: string
  };
  paymentTerm: {
    paymentTermId: number
    paymentTermCode: string
    paymentTermDesc: string
  };
  shippingSource: {
    shippingSourceId: number
    shippingSourceCode: string
    shippingSourceDesc: string
  };
}

export interface DetailResponseItem {
  orderId: number;
  shippingCondition: {
    shippingConditionId: number
    shippingConditionCode: string
    shippingConditionDesc: string
  };
  jobsite: {
    jobsiteId: number
    jobsiteCode: string
    jobsiteDesc: string
  };
  pointOfDelivery: {
    pointOfDeliveryId: number
    pointOfDeliveryCode: number
    pointOfDeliveryDesc: string
  };
  items: ItemResponseItem[];
}

export interface SearchResponseItem {
  searchType: string;
  type: number;
  value: string;
  valueType: string;
  valueId: string;
  details: DetailResponseItem[];
}
